module.exports = __webpack_public_path__ + "img/pt02_samurai02skin_shop.fe36ea85.png";